import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { LoanService } from 'src/app/services/loan';
import { Subscription } from 'rxjs';
import { GlobalSpinnerService } from 'src/app/shared/services/global-spinner.service';
import { ApplicationContextBoundComponent } from 'src/app/shared/components';
import { ApplicationContext, DocFileViewModel } from 'src/app/models';
import { isInlineRenderableMimeType, openBlobForViewing, resolveViewMimeType, toDownloadFileName } from 'src/app/shared/utils/file-type-utils';

@Component({
    selector: 'uw-decision',
    templateUrl: 'uw-decision.component.html',
    standalone: false
})

export class UWDecisionComponent extends ApplicationContextBoundComponent implements OnInit, OnDestroy {

    iframeUrl: string;

    /** The document, when the browser will not display it inline and it is offered as a download. */
    downloadableDocument: DocFileViewModel;

    private downloadableDocumentData: Uint8Array<ArrayBuffer>;

    errorMessage: string;

    testData: any;

    private _loanInfoChangesSubscription: Subscription;

  constructor(
    injector: Injector,
    private readonly _loanService: LoanService,
    private readonly _spinner: GlobalSpinnerService,
  ) {
    super(injector);
   }

  ngOnInit() {

    if (!this.applicationContext?.application) {
      this._loanInfoChangesSubscription =
        this.applicationContextService.loanInfoChanges.subscribe(({ context }) => {
          if (context.application) {
            this.initialize(context);
          }
        });
    } else {
      this.initialize(this.applicationContext);
    }
  }

  initialize = (context: ApplicationContext) => {
    this._spinner.show();
    this._loanService.getRecentUWDoc(context.application.applicationId).subscribe({
        next: (uwDoc) => {
            if (uwDoc) {
              this.viewFile(uwDoc);
            }
        },
        error: (err) => {
            this.errorMessage = err.message;
        }
    }).add(()=> {this._spinner.hide();})

  }

  viewFile = (docFile: DocFileViewModel) => {
    if (docFile.fileData) {
      const decodedData = window.atob(docFile.fileData);
      const uInt8Array = new Uint8Array(decodedData.length);
      for (let i = 0; i < decodedData.length; ++i) {
        uInt8Array[i] = decodedData.charCodeAt(i);
      }
      const viewMimeType = resolveViewMimeType(docFile.fileName, docFile.mimeType);
      if (!isInlineRenderableMimeType(viewMimeType)) {
        // The iframe cannot show the document - either the browser does not render the type at all, or
        // it is active content, which must not render in our origin - so offer it as a download instead.
        this.downloadableDocument = docFile;
        this.downloadableDocumentData = uInt8Array;
        return;
      }

      const blob = new Blob([uInt8Array], { type: viewMimeType });
      const url = window.URL.createObjectURL(blob);
      this.iframeUrl = url;
    }
  }

  downloadDocument = () => {
    openBlobForViewing(
      this.downloadableDocumentData,
      resolveViewMimeType(this.downloadableDocument.fileName, this.downloadableDocument.mimeType),
      toDownloadFileName(this.downloadableDocument.fileName, this.downloadableDocument.mimeType)
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this._loanInfoChangesSubscription) {
      this._loanInfoChangesSubscription.unsubscribe();
    }
  }
}
